import React from "react";

import { AccordionHeader, AccordionItem, AccordionPanel, Body1 } from "@fluentui/react-components";
import { PlugDisconnected20Filled } from "@fluentui/react-icons";

import TokenForm from "./components/TokenForm";

import { AccordionValue } from "../../config";

const PersonalAccessToken = () => {
  return (
    <AccordionItem value={AccordionValue.Token}>
      <AccordionHeader icon={<PlugDisconnected20Filled />}>
        <Body1>Personal Access Token</Body1>
      </AccordionHeader>
      <AccordionPanel>
        <TokenForm />
      </AccordionPanel>
    </AccordionItem>
  );
};

export default PersonalAccessToken;
